import React from 'react'
import { useTranslation } from 'react-i18next'

import NatureIcon from '@material-ui/icons/Nature'

import { useSavePlantsMutation } from '../../../../adapters/plants'
import UploadTreesCard from './UploadTreesCard'

export default function UploadTrees({
  parcel,
  refetchPlants,
  onUploaded,
  setStatusSnackbar,
  setMessageSnackbar,
  setOpenSnackbar,
}) {
  const { t } = useTranslation()
  const [reading, setReading] = React.useState(false)

  const mutateSavePlants = useSavePlantsMutation()

  const notify = (status, message) => {
    if (!setOpenSnackbar) return
    setStatusSnackbar(status)
    setMessageSnackbar(message)
    setOpenSnackbar(true)
  }

  const handleFileUploading = (files) => {
    if (files.length === 0) return

    setReading(true)
    const read = new FileReader()
    read.readAsText(files[0])

    read.onloadend = function () {
      let data
      try {
        data = JSON.parse(read.result)
      } catch (e) {
        setReading(false)
        notify('error', t('plants_upload.invalid_geojson'))
        return
      }

      mutateSavePlants.mutate([data, parcel?.id], {
        onSuccess: () => {
          setReading(false)
          notify('success', t('plants_upload.success'))
          if (onUploaded) onUploaded()
          if (refetchPlants) refetchPlants()
        },
        onError: () => {
          setReading(false)
          notify('error', t('plants_upload.error'))
        },
      })
    }

    read.onerror = function () {
      setReading(false)
      notify('error', t('plants_upload.error'))
    }
  }

  return (
    <UploadTreesCard
      icon={<NatureIcon />}
      title={parcel?.properties?.name || t('plants_upload.this_parcel')}
      scope={t('plants_upload.parcel_scope')}
      formats={['.geojson']}
      acceptedFiles={['.geojson', '.json', 'application/geo+json', 'application/json']}
      onRejected={() =>
        notify('error', t('plants_upload.parcel_format_error'))
      }
      busy={reading || mutateSavePlants.isLoading}
      busyText={t('plants_upload.uploading')}
      onFiles={handleFileUploading}
    />
  )
}
